<template>
    <div class="notice">
      <div>
        <!-- <span class="back" @click="routerTo('/pcpage/noticelist/notice_ul')">
          <img src="../img/arrow.png" alt=""> 赛事公告
        </span> -->
      </div>
      <div class="content">
        <!-- <div class="title">
          活动主旨
        </div> -->
        <p class="firstP">
          2021年“闪亮的青春”志愿者短视频与图片故事征集活动开启啦！为展现志愿者的青春风貌，讲述志愿者的美好故事，由语合中心发起的“闪亮的青春”视频与图片故事征集活动，向你发出邀请！
        </p>
      </div>
      <div class="content link">
        <div class="title">
          征集内容
        </div>
        <p>
          拍摄3张及以上的图片组成故事PLOG，或录制剪辑一段1至5分钟的视频VLOG，再配上PLOG或VLOG简要介绍。
        </p>
        <p class="p_0em">作品（PLOG、VLOG）主题：</p>
        <h2><img src="../img/icon.png" alt=""> 记录日常生活类：</h2>
        <h3>（1）开箱记录：赴任，我都准备了什么？</h3>
        <h3>（2）赴任：从我家到新家</h3>
        <h3>（3）志愿者的一天</h3>
        <h3>（4）挑战一周工作穿搭</h3>
        <h3>（5）志愿者上下班记录</h3>
        <h3>（6）我和学生的日常</h3>
        <h3>（7）打卡一周校园或住处天空日记</h3>
        <h3>（8）XXX国特有的交通工具</h3>
        <h3>（9）我的上班之路/交通工具（公交车、火车、出租车、走路）</h3>
        <h3>（10）打卡一周运动（日常运动即可）</h3>
        <h3>（11）介绍一位的当地朋友</h3>
        <h3>（12）我在国外看冬奥</h3>
        <h3>（13）这个你肯定没见过（可为当地水果、物件等）</h3>
        <h3>（14）与某个人告别（学生、同事、学校员工、邻居、朋友等）</h3>
        <h2><img src="../img/icon.png" alt=""> 唯有美食不可辜负类：</h2>
        <h3>（15）我在中超（亚超）买到的食物</h3>
        <h3>（16）10块钱人民币能在当地买到什么</h3>
        <h3>（17）让外国学生品尝中国特有零食</h3>
        <h3>（18）来XXX国，一定要吃的XXX小吃</h3>
        <h3>（19）厨神是怎样炼成的</h3>
        <h3>（20）逛一逛XXX地菜市场</h3>
        <h3>（21）一起做一道中国美食</h3>
        <h3>（22）一起做一道XXX国美食</h3>
        <h3>（23）我的冰箱日记</h3>
        <h3>（24）打卡一周早餐</h3>
        <h3>（25）来尝尝我们中国的烧烤/炸酱面/肉夹馍/凉皮……吧！</h3>
        <h2><img src="../img/icon.png" alt=""> 记录志愿者工作类：</h2>
        <h3>（26）一起来跳中国舞（武）</h3>
        <h3>（27）一起唱首中文歌</h3>
        <h3>（28）离别的礼物（志愿者可以为学生或是朋友准备告别礼物）</h3>
        <h3>（29）我的得意之作（一次成功的教学或学生的表现）</h3>
        <h3>（30）我的地盘我做主（教室布置）</h3>
        <h3>（31）我的高光时刻（在当地获得奖项、受到的欢迎或称赞）</h3>
        <h3>（32）最后一课</h3>
        <h3>（33）中华才艺方面：最美的舞台，最美的学生（娃）</h3>
        <h3>（34）一起来制作教具</h3>
        <h3>（35）我的学校是这样的</h3>
        <h3>（36）秀一秀我学生写的字（作业）</h3>
        <h3>（37）我给学生起中文名字</h3>
        <h3>（38）教外国人说绕口令是一种什么体验</h3>
        <h3>（39）这几种水果/饮料/称呼/用中文/当地语言怎么说</h3>
        <h3>（40）我的学生是天使</h3>
        <h3>（41）学生教我学当地语言（互当老师）</h3>
        <h3>（42）外国学生的一天</h3>
        <h3>（43）XXX国人眼中的中国人</h3>
        <h3>（44）中国人眼中的XXX国人</h3>
        <h3>（45）和学生郊游/户外活动的一天</h3>
        <h3>（46）课堂中的搞笑瞬间</h3>
        <h3>（47）课堂小游戏</h3>
        <h3>（48）我的教案</h3>
        <h3>（49）汉服初体验</h3>
        <h3>（50）花式晒学生的成绩单（汉语考试）</h3>
        <h3>（51）办签证，你必须知道这几件事</h3>
        <h2><img src="../img/icon.png" alt=""> 自由创意类</h2>
        <h3>（52）当志愿者前VS当志愿者后</h3>
        <h3>（53）朋友眼中的志愿者/父母眼中的志愿者/真正的志愿者</h3>
        <h3>（54）志愿者的进化论：教师→厨师→摄影师</h3>
        <h3>（55）中国和XXX国有哪些不同？</h3>
        <h3>（56）我在XXX国遇到的感动的事/感动的人</h3>
        <h2><img src="../img/icon.png" alt=""> 抗疫类：</h2>
        <h3>（57）去打疫苗啦</h3>
        <h3>（58）疫情期间，我的防疫小妙招</h3>
        <h3>（59）疫情期间，我是如何上网课的</h3>
        <h3>（60）疫情期间，志愿者的一天</h3>
        <h3>（61）我的隔离生活</h3>
        <h3>（62）打卡隔离餐</h3>
        <h2><img src="../img/icon.png" alt=""> 风俗节日类：</h2>
        <h3>（63）我在国外过XXX节/春节/春晚</h3>
        <h3>（64）和当地学生/家庭庆祝当地节日</h3>
        <h3>（65）XXX国家特有的风土人情</h3>
        <h3>（66）XXX国的教师节</h3>
        <h3>（67）XXX学校的校庆</h3>
        <h3>（68）今天是XXX的生日</h3>
        <h3>（69）来XXX国，你不能不知道的禁忌</h3>
        <h2><img src="../img/icon.png" alt=""> 离任感想：</h2>
        <h3>（70）我的工作交接清单</h3>
        <h3>（71）我想对下一任志愿者说</h3>
        <h3>（72）我想对学生说</h3>
        <h3>（73）用三个词形容一下你的志愿者经历</h3>
        <h3>（74）我的下一站……（留任/转岗/公派老师/就业的原因）</h3>
        <h3>（75）晒一晒我的书单</h3>
        <h3>（76）告别的机场</h3>
        <h2><img src="../img/icon.png" alt=""> 我与亲人们的情感</h2>
        <h3>（77）在XXX国，我想跟谁说……</h3>
        <h3>（78）我和家人的日常联络</h3>
        <h3>（79）一幅画/一首歌/一首诗/一句话解乡愁</h3>
        <h3>（80）我要把这件物品带回去给ta</h3>
      </div>
      <div class="content link">
        <div class="title">
          征集规则
        </div>
        <h2>
          <img src="../img/icon_1.png" alt=""> 参赛人员：
        </h2>
        <h3>
          （1）即将赴任、在任和往届的国际中文教育志愿者；
        </h3>
        <h3>（2）公派教师、专职教师、任教机构的工作人员、志愿者身边的相关人员（其作品内容必须反映志愿者的工作与生活）。</h3>
        <h2>
          <img src="../img/icon_1.png" alt=""> 作品征集时间：2021年11月23日-2022年6月30日
        </h2>
        <h2>
          <img src="../img/icon_1.png" alt=""> 作品要求：
        </h2>
        <h2>
          <img src="../img/icon_3.png" alt=""> 图片类:PLOG
        </h2>
        <h3>
          （1）志愿者在参加选拔、培训以及任教期间拍摄的或以他人视角拍摄的与志愿者有关的3张或3张以上照片组成PLOG图组，并具有故事性；
        </h3>
        <h3>
          （2）PLOG要求参赛者，通过作品组织作品的故事情节、并从整体图片的取景、构图、用光及用色等方面进行拍摄，并以此作为评审依据；同时，要求参赛者进行同一主题的多幅作品的摄制，要求画面真实、多角度地反映志愿者的工作与生活、所见与所感，专家也将以此进行评审的参考，全部作品不得摆拍；
        </h3>
        <h3>
          （3）图片中不得带有黄、赌、毒及任何带有政治色彩的画面。
        </h3>
        <h3>
          （4）故事图组题目限定在50字以内；图组及图组中的图片描述在150字以内；另需根据要求注明拍摄时间、拍摄地点等信息；
        </h3>
        <h3>
          （5）在提交PLOG作品时，每组最少为3张图片，最多为10张，并通过文字说明，描述故事中的内容，文字内容需与图片内容相符，否则审核不予通过，不能进行展示；
        </h3>
        <h3>
          （6）要求不得对原始照片进行影响其真实性的改动，不得进行任何形式的装裱，但可进行调光或图片大小的微调整；
        </h3>
        <h3>
          （7）每位参赛者最多可上传10组图组，并提交参赛；
        </h3>
        <h3>
          （8）图片作品格式要求为JPG格式，故事图组中每单幅图片原始文件大小不小于2MB，不大于5MB。
        </h3>
        <h2>
          <img src="../img/icon_3.png" alt=""> 视频类:VLOG
        </h2>
        <h3>（1）志愿者在参加选拔、培训以及任教期间拍摄的或以他人视角拍摄的与志愿者有关的视频作品；</h3>
        <h3>（2）根据视频拍摄的时间及地点，正确录入相关文字信息，同时对视频做简单的文字摘要。视频题目字数限制在50字以内，描述限制在150字以内；每位用户可最多上传10段视频。</h3>
        <h3>（3）视频中不得带有黄、赌、毒及任何带有政治色彩的镜头。</h3>
        <h3>（4）视频拍摄及剪辑格式及要求：</h3>
        <p>
          视频拍摄工具不限，可以使用手机、专业相机或特种摄像机，拍摄完成的内容可进行剪辑、调色等相关处理。
        </p>
        <p>视频时长：1-5分钟</p>
        <p>画幅宽高比：16:9，全部统一横版</p>
        <p>建议分辨率：1280 x720像素或1920x1080像素（16:9），像素尽量高，画质尽量清晰</p>
        <p>视频帧数：25帧</p>
        <p>视频文件质量大小：1GB以内（如视频过大请用相关软件进行转码、压缩处理）</p>
        <p>视频格式：建议使用MP4（或其他主流视频格式文件） 视频编码建议使用H.264编码器 比特率建议控制在 1200kb/秒以内。 如视频中语言为外文，请在视频画面中添加中文字幕或在简介中录入中文内容。可通过手机或电脑端进行成片视频源文件提交。</p>
        <h2>
          <img src="../img/icon_3.png" alt=""> 提交作品方式
        </h2>
        <h3>
          （1）以在线上传的方式提交作品，参赛者可通过志愿者俱乐部官方微信号，或使用电脑或手机进入“2021年志愿者短视频与图片故事征集大赛”专题（网址为：https://collection2021.chineseplus.net/）的作品上传页面提交作品；
        </h3>
        <h3>
          （2）作品上传需在大赛专题网页进行注册，注册后方可提交作品参赛或进行助推和投票；
        </h3>
        <h3>
          （3）提交作品过程中，需按要求填写相应的关键词部分，以避免作品检索不到；
        </h3>
        <h3>
          （4）上传的作品需经1-2天审核，审核状态可登录“作品管理”页面查看，请不要重复提交相同作品；
        </h3>
        <h3>
          （5）网络环境较差的，可以通过官方邮箱进行作品提交，由工作人员完成作品上传；
        </h3>
        <h3>
          （6）活动联系:
          <p>
            邮箱：zhengji@chineseplus.net
          </p>
          <p>
            联系电话：+8610 59307519（请在工作时间进行联络，时间以北京时间为准。）
          </p>
          
        </h3>
        <h3>
          （7）考虑到发布平台对音乐以及包装的版权要求，建议同步上传视频无包装的原始素材，提供成片无字幕、无音乐、无包装、无压缩、无边框净版，以便后期加工处理。
        </h3>
        <h2>
          <img src="../img/icon_3.png" alt=""> 版权申明：
        </h2>
        <h3>（1）参赛者的参赛作品必须是本人拥有著作权的作品，其中合作作品须是合作者共同参赛或一人参赛的参赛者拥有独立发表权；</h3>
        <h3>（2）作品涉及的名誉权、著作权、肖像权等法律问题，均由作品提供者自行承担，同时参赛者声明参赛作品不侵犯第三方著作权；</h3>
        <h3>（3）大赛主办方及合作媒体有权将参赛作品重复使用于宣传为目的的出版、发表、展览、演示等用途，不另付稿酬；</h3>
        <h3>（4）评选结果公布后，获奖的优秀参赛作品根据情况会被要求提交满足宣传出版和展览质量要求的原始图片，以及视频无包装的原始素材，提供成片无字幕、无音乐、无包装、无压缩、无边框净版；</h3>
        <h3>（5）参赛作品不可为往届大赛获奖作品；</h3>
        <h3>（6）凡投稿者，即视为已同意本次征集大赛相关规定。</h3>
      </div>
      <div class="content link">
        <div class="title">
          评选规则
        </div>
        <h2>
          <img src="../img/icon_3.png" alt=""> 评选办法：
        </h2>
        <p class="em_1">
        （1）所有参赛作品经审核后发布在<strong>“2021年志愿者短视频与图片故事征集活动”</strong>专题网页进行展示，参赛者及网络注册用户可登录大赛页面后进行在线助推或投票，上传及展示时间为2021年11月24日至2022年6月30日在专题上传阶段进行（助推的优秀作品，将有机会通过“国际中文教育志愿者俱乐部”公众号进行展示和推荐，并有可能与获奖作品一同获得中外语言合作交流中心全球推广和宣传的机会。）
        
        </p>
        <p>
          投票时间将在征集上传工作结束后，于2022年7月1日至2022年7月31日进行，投票结果将最终产生“最佳人气奖”。
        </p>
        <p class="em_1">
          （2）每个ID对每个作品每天限助推或投票1次。如发现利用网络工具刷票现象，将取消该作品的得票数，情节严重者将取消该作者的参赛资格;
        </p>
        <p class="em_1">
          （3）组织专家评审团，根据照片故事性、技术指标等各项信息，进行为期三轮的评选，并参考得票情况，评选出获奖作品；
        </p>
        <p class="em_1">
          （4）每位参赛者最多只能有一个作品（故事图组或视频）获得某一类别奖项；
        </p>
        <p class="em_1">
          （5）获奖作品及助推的优秀作品，将有机会获得“国际中文教育志愿者俱乐部”公众号及中外语言合作交流中心进行全球推广和宣传的机会。
        </p>
        <p class="em_1">
          （6）获得“国际中文教育志愿者俱乐部”公众号及中外语言合作交流中心推广和宣传机会的作品，将依据版权申明评定、执行。
        </p>
        <p class="em_1">
          （7）所有获奖作品及优秀奖作品及奖品信息将在“2021年志愿者短视频与图片故事征集活动”专题网页公布。公布展示时间为2022年10月。
        </p>
        <p class="em_1">
          （8）获奖作品作者将获得丰厚的奖品。
        </p>
        <!-- <p class="p_left">
          一等奖：3人，其中视频类：2人、图片类：1人
        </p>
        <p class="p_left">二等奖：10人，其中视频类：6人、图片类：4人</p>
        <p class="p_left">三等奖：20人，其中视频类：15人、图片类：5人</p>
        <p class="p_left">优秀奖：40人，其中视频类：30人、图片类：10人</p>
        <p class="p_left">最佳人气奖：2人，其中视频类：1人、图片类：1人</p>
        <p class="p_left">参与奖：所有参与投稿的志愿者，均可获得参与奖相关证书。</p> -->
        <div class="joinCon">
          <img src="../img/join.png" alt="" class="join" @click="routerTo('/pcpage/submitlist/submit')">    
        </div>
      </div>
      
    </div>
</template>

<script>
export default {
    name: 'notice',
    data: function () {
        return {
            
        }
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
    width: 1200px;
    margin: 80px auto 50px;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .back {
      font-size: 24px;
      color: #0b0b0b;
      font-weight: bold;
      cursor: pointer;
      img {
        vertical-align: middle;
        margin-top: -4px;
      }
    }
    .content {
      width: 1200px;
      background-color: #fff;
      padding: 0 40px 70px;
      text-align: center;
      margin-top: 40px;
      box-sizing: border-box;
      .title {
        position: relative;
        top: -35px;
        width: 405px;
        height: 70px;
        line-height: 65px;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 35px;
        text-align: center;
        font-size: 50px;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -60px;
          top: 15px;
          content: '';
          display: inline-block;
          width: 60px;
          height: 60px;
          background-image: url(../img/left.png);
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -80px;
          top: 15px;
          content: '';
          display: inline-block;
          width: 60px;
          height: 60px;
          background-image: url(../img/right.png);
          background-repeat: no-repeat;
        }
      }
      
      p {
        text-align: left;
        font-size: 28px;
        color: #0b2ab0;
        line-height: 1.4;
        margin-top: 20px;
        text-indent: 2em;
        strong {
          font-weight: bold;
        }
      }
      .firstP {
        padding-top: 30px;
      }
      .p_0em {
        text-indent: 0em;
      }
      .p_left {
        text-indent: 3.5em;
      }
      h2 {
        font-size: 28px;
        font-weight: bold;
        color: #0b2ab0;
        text-align: left;
        margin-top: 35px;
        img {
          width: 30px;
          vertical-align: top;
        }
      }
      h3 {
        font-size: 28px;
        line-height: 1.4;
        color: #0b2ab0;
        text-align: left;
        margin-top: 20px;
        text-indent: 1em;
        img {
          width: 35px;
          vertical-align: top;
        }
        // strong {
        //   font-weight: bold;
        // }
      }
      .em_1 {
        text-indent: 1em;
      }
      .mgl {
        margin-left: 6em;
      }
    }
    .link {
      position: relative;
      margin-top: 65px;
      &:before {
        content: '';
        position: absolute;
        left: 58px;
        top: -88px;
        background-image: url(../img/link.png);
        background-repeat: no-repeat;
        background-size: 100%;
        width: 22px;
        height: 110px;
      }
      &:after {
        content: '';
        position: absolute;
        right: 58px;
        top: -88px;
        background-image: url(../img/link.png);
        background-repeat: no-repeat;
        background-size: 100%;
        width: 22px;
        height: 110px;
      }
    }
    .joinCon {
      text-align: center;
      .join {
        margin: 40px auto 0;
        cursor: pointer;
      }
    }
}
</style>
